import { SentryLogging } from "./sending_sentry_logs";
import { calculation_metric } from './upperBodyAROM';

const adduction_abduction_right = [];
const adduction_abduction_left = [];
const shoulder_flexion_extension_right = [];
const shoulder_flexion_extension_left = [];
const elbow_flexion_extension_right = [];
const elbow_flexion_extension_left = [];
const internal_external_shoulder_rotation_right = [];
const internal_external_shoulder_rotation_left = [];

/**
* Measures the angle formed at pointB by points A and C.
* @param {Object} pointA - {x, y} coordinates of point A.
* @param {Object} pointB - {x, y} coordinates of point B (vertex).
* @param {Object} pointC - {x, y} coordinates of point C.
* @returns {number} - Angle in degrees between 0 and 180.
*/
function measure_angle(pointA, pointB, pointC) {
  let vectorBA = [pointA.x - pointB.x, pointA.y - pointB.y];
  let vectorBC = [pointC.x - pointB.x, pointC.y - pointB.y];
  let angle = Math.abs((Math.atan2(vectorBC[1], vectorBC[0]) - Math.atan2(vectorBA[1], vectorBA[0])) * (180 / Math.PI));
  return angle > 180 ? 360 - angle : angle;
}

/**
* Records adduction/abduction ranges for shoulders during assessment.
* @param {Object} arom - Instance of UpperBodyArom
* @param {Array} poses - Array of detected poses.
*/
export function recordAdductionAbduction(arom, poses) {
  arom.arom_right_high_text.textContent = "Abduction";
  arom.arom_right_low_text.textContent = "Adduction";
  arom.arom_left_high_text.textContent = "Abduction";
  arom.arom_left_low_text.textContent = "Adduction";
  
  poses.forEach(pose => {
    arom.angle_value = measure_angle(
      { x: pose.keypoints[12].x, y: pose.keypoints[12].y + 100 },
      { x: pose.keypoints[12].x, y: pose.keypoints[12].y },
      { x: pose.keypoints[14].x, y: pose.keypoints[14].y }
    );
    if (pose.keypoints[12].x <= pose.keypoints[14].x) {
      arom.angle_value = pose.keypoints[12].y > pose.keypoints[14].y ? 180 : 0;
    }
    adduction_abduction_right.push(arom.angle_value);
    if (arom.angle_value != null) {
      calculation_metric.adduction_abduction.right_abduction =
      Math.max(calculation_metric.adduction_abduction.right_abduction || 0, arom.angle_value);
      calculation_metric.adduction_abduction.right_adduction =
      Math.min(calculation_metric.adduction_abduction.right_adduction || Infinity, arom.angle_value);
    }
  });
  
  arom.arom_right_high_value.innerText = `${Math.round(calculation_metric.adduction_abduction.right_abduction)}°`;
  arom.arom_right_low_value.innerText = `${Math.round(calculation_metric.adduction_abduction.right_adduction)}°`;
  arom.arom_assessment_counter_right.innerText = `${Math.round(arom.angle_value)}°`;
  
  poses.forEach(pose => {
    arom.angle_value = measure_angle(
      { x: pose.keypoints[11].x, y: pose.keypoints[11].y + 100 },
      { x: pose.keypoints[11].x, y: pose.keypoints[11].y },
      { x: pose.keypoints[13].x, y: pose.keypoints[13].y }
    );
    if (pose.keypoints[11].x >= pose.keypoints[13].x) {
      arom.angle_value = pose.keypoints[11].y >= pose.keypoints[13].y ? 180 : 0;
    }
    adduction_abduction_left.push(arom.angle_value);
    if (arom.angle_value != null) {
      calculation_metric.adduction_abduction.left_abduction =
      Math.max(calculation_metric.adduction_abduction.left_abduction || 0, arom.angle_value);
      calculation_metric.adduction_abduction.left_adduction =
      Math.min(calculation_metric.adduction_abduction.left_adduction || Infinity, arom.angle_value);
    }
  });
  
  arom.arom_left_high_value.innerText = `${Math.round(calculation_metric.adduction_abduction.left_abduction)}°`;
  arom.arom_left_low_value.innerText = `${Math.round(calculation_metric.adduction_abduction.left_adduction)}°`;
  arom.arom_assessment_counter_left.innerText = `${Math.round(arom.angle_value)}°`;
}

/**
* Records left shoulder flexion and extension during assessment.
* @param {Object} arom - Instance of UpperBodyArom
* @param {Array} poses - Array of detected poses.
*/
export function recordLeftShoulderFlexExt(arom, poses) {
  arom.arom_left_high_text.textContent = "Flexion";
  arom.arom_left_low_text.textContent = "Extension";
  
  poses.forEach(pose => {
    arom.angle_value = measure_angle(
      { x: pose.keypoints[12].x, y: pose.keypoints[12].y + 100 },
      { x: pose.keypoints[12].x, y: pose.keypoints[12].y },
      { x: pose.keypoints[14].x, y: pose.keypoints[14].y }
    );
    if (pose.keypoints[12].x >= pose.keypoints[14].x) {
      arom.angle_value = pose.keypoints[12].y >= pose.keypoints[14].y ? 180 : 0;
    }
    shoulder_flexion_extension_right.push(arom.angle_value);
    calculation_metric.shoulder_flexion_extension.right_flexion =
    Math.max(calculation_metric.shoulder_flexion_extension.right_flexion || 0, arom.angle_value);
    calculation_metric.shoulder_flexion_extension.right_extension =
    Math.min(calculation_metric.shoulder_flexion_extension.right_extension || Infinity, arom.angle_value);
  });
  
  arom.arom_left_high_value.innerText = `${Math.round(calculation_metric.shoulder_flexion_extension.right_flexion)}°`;
  arom.arom_left_low_value.innerText = `${Math.round(calculation_metric.shoulder_flexion_extension.right_extension)}°`;
  arom.arom_assessment_counter_left.innerText = `${Math.round(arom.angle_value)}°`;
}

/**
* Records right shoulder flexion and extension during assessment.
* @param {Object} arom - Instance of UpperBodyArom
* @param {Array} poses - Array of detected poses.
*/
export function recordRightShoulderFlexExt(arom, poses) {
  arom.arom_right_high_text.textContent = "Flexion";
  arom.arom_right_low_text.textContent = "Extension";
  
  poses.forEach(pose => {
    arom.angle_value = measure_angle(
      { x: pose.keypoints[11].x, y: pose.keypoints[11].y + 100 },
      { x: pose.keypoints[11].x, y: pose.keypoints[11].y },
      { x: pose.keypoints[13].x, y: pose.keypoints[13].y }
    );
    if (pose.keypoints[11].x <= pose.keypoints[13].x) {
      arom.angle_value = pose.keypoints[11].y > pose.keypoints[13].y ? 180 : 0;
    }
    shoulder_flexion_extension_left.push(arom.angle_value);
    calculation_metric.shoulder_flexion_extension.left_flexion =
    Math.max(calculation_metric.shoulder_flexion_extension.left_flexion || 0, arom.angle_value);
    calculation_metric.shoulder_flexion_extension.left_extension =
    Math.min(calculation_metric.shoulder_flexion_extension.left_extension || Infinity, arom.angle_value);
  });
  
  arom.arom_right_high_value.innerText = `${Math.round(calculation_metric.shoulder_flexion_extension.left_flexion)}°`;
  arom.arom_right_low_value.innerText = `${Math.round(calculation_metric.shoulder_flexion_extension.left_extension)}°`;
  arom.arom_assessment_counter_right.innerText = `${Math.round(arom.angle_value)}°`;
}

/**
* Records left elbow flexion and extension during assessment.
* @param {Object} arom - Instance of UpperBodyArom
* @param {Array} poses - Array of detected poses.
*/
export function recordLeftElbowFlexionExtension(arom, poses) {
  arom.arom_left_high_text.textContent = "Flexion";
  arom.arom_left_low_text.textContent = "Extension";
  
  poses.forEach(pose => {
    arom.angle_value = 180 - measure_angle(
      { x: pose.keypoints[12].x, y: pose.keypoints[12].y },
      { x: pose.keypoints[14].x, y: pose.keypoints[14].y },
      { x: pose.keypoints[16].x, y: pose.keypoints[16].y }
    );
    if (arom.angle_value > 180) arom.angle_value = 180;
    if (arom.angle_value < 0) arom.angle_value = 0;
    elbow_flexion_extension_right.push(arom.angle_value);
    calculation_metric.elbow_flexion_extension.right_flexion =
    Math.max(calculation_metric.elbow_flexion_extension.right_flexion || 0, arom.angle_value);
    calculation_metric.elbow_flexion_extension.right_extension =
    Math.min(calculation_metric.elbow_flexion_extension.right_extension || Infinity, arom.angle_value);
  });
  
  arom.arom_left_high_value.innerText = `${Math.round(calculation_metric.elbow_flexion_extension.right_flexion)}°`;
  arom.arom_left_low_value.innerText = `${Math.round(calculation_metric.elbow_flexion_extension.right_extension)}°`;
  arom.arom_assessment_counter_left.innerText = `${Math.round(arom.angle_value)}°`;
}

/**
* Records right elbow flexion and extension during assessment.
* @param {Object} arom - Instance of UpperBodyArom
* @param {Array} poses - Array of detected poses.
*/
export function recordRightElbowFlexionExtension(arom, poses) {
  arom.arom_right_high_text.textContent = "Flexion";
  arom.arom_right_low_text.textContent = "Extension";
  
  poses.forEach(pose => {
    arom.angle_value = 180 - measure_angle(
      { x: pose.keypoints[11].x, y: pose.keypoints[11].y },
      { x: pose.keypoints[13].x, y: pose.keypoints[13].y },
      { x: pose.keypoints[15].x, y: pose.keypoints[15].y }
    );
    if (arom.angle_value > 180) arom.angle_value = 180;
    if (arom.angle_value < 0) arom.angle_value = 0;
    elbow_flexion_extension_left.push(arom.angle_value);
    calculation_metric.elbow_flexion_extension.left_flexion =
    Math.max(calculation_metric.elbow_flexion_extension.left_flexion || 0, arom.angle_value);
    calculation_metric.elbow_flexion_extension.left_extension =
    Math.min(calculation_metric.elbow_flexion_extension.left_extension || Infinity, arom.angle_value);
  });
  
  arom.arom_right_high_value.innerText = `${Math.round(calculation_metric.elbow_flexion_extension.left_flexion)}°`;
  arom.arom_right_low_value.innerText = `${Math.round(calculation_metric.elbow_flexion_extension.left_extension)}°`;
  arom.arom_assessment_counter_right.innerText = `${Math.round(arom.angle_value)}°`;
}

/**
* Records left shoulder internal/external rotation during assessment.
* @param {Object} arom - Instance of UpperBodyArom
* @param {Array} poses - Array of detected poses.
*/
export function recordLeftInternalExternalShoulderRotation(arom, poses) {
  arom.arom_left_high_text.textContent = "Internal";
  arom.arom_left_low_text.textContent = "External";
  
  poses.forEach(pose => {
    arom.angle_value = measure_angle(
      { x: pose.keypoints[14].x, y: pose.keypoints[24].y },
      { x: pose.keypoints[14].x, y: pose.keypoints[14].y },
      { x: pose.keypoints[16].x, y: pose.keypoints[16].y }
    );
    if (arom.angle_value < 0) arom.angle_value = 0;
    if (arom.angle_value < 90) {
      arom.angle_value = 90 - arom.angle_value;
      calculation_metric.internal_external_shoulder_rotation.right_internal =
      Math.max(calculation_metric.internal_external_shoulder_rotation.right_internal || 0, arom.angle_value);
    } else {
      arom.angle_value = arom.angle_value - 90;
      calculation_metric.internal_external_shoulder_rotation.right_external =
      Math.max(calculation_metric.internal_external_shoulder_rotation.right_external || 0, arom.angle_value);
    }
    internal_external_shoulder_rotation_right.push(arom.angle_value);
  });
  
  arom.arom_left_high_value.innerText = `${Math.round(calculation_metric.internal_external_shoulder_rotation.right_internal)}°`;
  arom.arom_left_low_value.innerText = `${Math.round(calculation_metric.internal_external_shoulder_rotation.right_external)}°`;
  arom.arom_assessment_counter_left.innerText = `${Math.round(arom.angle_value)}°`;
}

/**
* Records right shoulder internal/external rotation during assessment.
* @param {Object} arom - Instance of UpperBodyArom
* @param {Array} poses - Array of detected poses.
*/
export function recordRightInternalExternalShoulderRotation(arom, poses) {
  arom.arom_right_high_text.textContent = "Internal";
  arom.arom_right_low_text.textContent = "External";
  
  poses.forEach(pose => {
    arom.angle_value = measure_angle(
      { x: pose.keypoints[13].x, y: pose.keypoints[23].y },
      { x: pose.keypoints[13].x, y: pose.keypoints[13].y },
      { x: pose.keypoints[15].x, y: pose.keypoints[15].y }
    );
    if (arom.angle_value < 0) arom.angle_value = 0;
    if (arom.angle_value < 90) {
      arom.angle_value = 90 - arom.angle_value;
      calculation_metric.internal_external_shoulder_rotation.left_internal =
      Math.max(calculation_metric.internal_external_shoulder_rotation.left_internal || 0, arom.angle_value);
    } else {
      arom.angle_value = arom.angle_value - 90;
      calculation_metric.internal_external_shoulder_rotation.left_external =
      Math.max(calculation_metric.internal_external_shoulder_rotation.left_external || 0, arom.angle_value);
    }
    internal_external_shoulder_rotation_left.push(arom.angle_value);
  });
  
  arom.arom_right_high_value.innerText = `${Math.round(calculation_metric.internal_external_shoulder_rotation.left_internal)}°`;
  arom.arom_right_low_value.innerText = `${Math.round(calculation_metric.internal_external_shoulder_rotation.left_external)}°`;
  arom.arom_assessment_counter_right.innerText = `${Math.round(arom.angle_value)}°`;
}

/**
* Logs all accumulated frame-wise data.
*/
export async function UpperBodyAromSentryLogging() {
  adduction_abduction_right.forEach((v, i) => console.log(`adduction_abduction_right ${i}: ${v}`));
  adduction_abduction_left.forEach((v, i) => console.log(`adduction_abduction_left ${i}: ${v}`));
  shoulder_flexion_extension_right.forEach((v, i) => console.log(`shoulder_flexion_extension_right ${i}: ${v}`));
  shoulder_flexion_extension_left.forEach((v, i) => console.log(`shoulder_flexion_extension_left ${i}: ${v}`));
  elbow_flexion_extension_right.forEach((v, i) => console.log(`elbow_flexion_extension_right ${i}: ${v}`));
  elbow_flexion_extension_left.forEach((v, i) => console.log(`elbow_flexion_extension_left ${i}: ${v}`));
  internal_external_shoulder_rotation_right.forEach((v, i) => console.log(`internal_external_shoulder_rotation_right ${i}: ${v}`));
  internal_external_shoulder_rotation_left.forEach((v, i) => console.log(`internal_external_shoulder_rotation_left ${i}: ${v}`));
  
  document.getElementById("arom-realtime-angle-left").style.display = "none";
  document.getElementById("arom-realtime-angle-right").style.display = "none";
  SentryLogging("Upper Body AROM");
}
